/**
 * Team page — localization manifest.
 */
export const teamManifest: readonly string[] = [
  "team.title",
  "team.invite",
  "team.members",
  "team.manageDescription",
  "team.inviteMember",
  "team.inviteModalTitle",
  "team.sendInvite",
  "team.removeConfirmation",
  // Shared
  "nav.team",
  "common.loading",
  "common.noData",
  "common.name",
  "common.email",
  "common.role",
  "common.actions",
  "common.save",
  "common.cancel",
  "common.delete",
  "common.confirm",
] as const;
